var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footerpart",attrs:{"app":"","color":"white","inset":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" — by ticktack.com")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }